module.exports = __webpack_public_path__ + "img/avatar7.95e8ee78.png";